// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__dHtF5","legacyBtn":"MutateMid_legacyBtn__5E6yj"};